import { Component, Vue, Watch } from 'vue-property-decorator';
import cookie from '@/assets/js/cookie/cookie';
import check from '@/assets/js/check/check';
import compress from '@/assets/js/compress/compress';
import config from '../../../api/params.config';
import { ImagePreview } from 'vant';

declare const wx: any;

@Component({})
export default class Prove extends Vue {
    private $api: any;
    private isMobile: boolean = true; // 是否在移动端打开
    private noticeShow: boolean = true; // 展示拍照须知
    private fromType: any = 0; // 来源员工类型(0：普通员工；1：优工)
    private proveStorage: any = '';  // 缓存信息
    private infoShow: boolean = false;
    private userCode: string = '';
    private userName: string = '';
    private requestIDCode: boolean = false; // 是否需要手动输入身份证号
    private userIDCode: string = ''; // 手动输入的身份证号
    private imgIDCode: string = ''; // 身份证照片中解析出的身份证号
    private userType: number = 0; // 员工类型(0：普通员工/优工；1：小工)
    private userHeadUrl: string = ''; // 登录人头像
    private userSex: number = 0; // 登录人性别
    private hadHead: boolean = false; // 展示申请人头像
    private isFemale: boolean = false; // 展示女士红色头像
    private noSex: boolean = true; // 展示(男士/默认)蓝色头像
    private isEncrypt: boolean = false; // 是否加密
    private IDCardList: any = []; // 已上传的身份证正面照
    private LiveList: any = []; // 已上传的生活照
    private ImgStr: any = []; // 图片Base64
    private limitImgSize: any = 5 * 1024 * 1024; // 限制上传图片大小
    private IDCardInfo: any = {}; // 身份证Ali返回的Url和Id
    private LiveInfo: any = {}; // 生活照Ali返回的Url和Id
    private FileList: any = []; // 文件保存信息
    private isDisabled: boolean = true;
    private reactURL: any = ''; // 保存到人脸库后跳转url
    public mounted() {
        const queryModal = {
            queryCode: this.$route.query.codeStr,
            isEncrypt: this.$route.query.isEncrypt,
        };
        this.reactURL = this.$route.query.reactURL;
        this.fromType = this.$route.query.fromType;
        this.init(queryModal);
    }
    // 初始化
    private async init(queryModal: any) {
        // 是否在移动端打开
        function CheckMobile() {
            const userAgentInfo = navigator.userAgent;
            const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
            for (const i of Agents) {
                if (userAgentInfo.indexOf(i) >= 0) {
                    return true;
                }
            }
            return false;
        }
        if (CheckMobile()) {
            this.isMobile = true;
            this.$toast.loading({
                duration: 0,       // 持续展示toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '正在加载...',
            });
        } else {
            this.isMobile = false;
            return;
        }
        // 获取工号
        if (window.localStorage.getItem('THIS_LOCATION_HREF_QUERY') !== '' && window.localStorage.getItem('THIS_LOCATION_HREF_QUERY') !== null) {
            this.proveStorage = JSON.parse(window.localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '');
        }  
        if ((this.proveStorage !== '' && this.proveStorage.from === 'qyWechat') || !check.checkNull(this.$route.query)) {
            // 从企业微信缓存中获取当前登录人的工号
            this.userCode = cookie.get('CURLOGINNAME');
            this.isEncrypt = false;
            this.getInfo();
        } else if (queryModal.queryCode !== '' && queryModal.queryCode !== undefined && queryModal.queryCode !== null) {
            // 从外部链接中获取当前登录人的工号
            this.userCode = queryModal.queryCode;
            this.isEncrypt = queryModal.isEncrypt;
            this.getInfo();
        } else if (this.fromType === '1') {
            // 优工入口，需要手动填写身份证号码获取工号，展示身份证输入框
            this.requestIDCode = true;
            this.$toast.clear();
            this.infoShow = true;
        }   
    }
    // 获取人员信息
    private async getInfo() {
        const modal = {
            codeStr: this.userCode,
            isEncrypt: this.isEncrypt,
        };
        // 获取当前登录人信息
        const userData = await this.$api.httpGet('BaiDuApi/BaiDuFace/GetUserInfoByCode', modal);
        if (userData.Success) {
            if (userData.Data) {
                this.userName = userData.Data.UserName;
                this.userHeadUrl = userData.Data.ImgUrl;
                this.userSex = userData.Data.Sex;
                if (this.userHeadUrl !== '' && this.userHeadUrl !== null && this.userHeadUrl !== undefined) {
                    this.hadHead = true;
                    this.noSex = false;
                    this.isFemale = false;
                } else if (this.userSex !== undefined) {
                    if (this.userSex === 0) {
                        this.noSex = true;
                        this.hadHead = false;
                        this.isFemale = false;
                    } else {
                        this.isFemale = true;
                        this.hadHead = false;
                        this.noSex = false;
                    }
                } else {
                    this.noSex = true;
                    this.hadHead = false;
                    this.isFemale = false;
                }
                this.$toast.clear();
                this.infoShow = true;
            } else {
                this.$dialog.alert({
                    title: '错误',
                    message: '未查询到登录人信息，请联系管理员。',
                });
                return;
            }            
        } else {
            this.$dialog.alert({
                title: '错误',
                message: userData.AllMessages,
            });
            return;
        }
        this.collectedCheck();
    }
    // 根据身份证号查询人员信息
    private async getInfoByIDCode() {
        const modal = {
            idCard: this.userIDCode,
        };
        // 获取身份证号对应的人员信息
        const userData = await this.$api.httpGet('BaiDuApi/BaiDuFace/QueryUserInfoByIdCard', modal);
        if (userData.Success) {
            if (userData.Data) {
                this.userName = userData.Data.UserName;
                this.userCode = userData.Data.Code;
                this.userType = userData.Data.Type;
            } else {
                this.$dialog.alert({
                    title: '错误',
                    message: '未查询到登录人信息，请联系管理员。',
                });
                return;
            }            
        } else {
            this.$dialog.alert({
                title: '错误',
                message: userData.AllMessages,
            });
            return;
        }
        this.collectedCheck();
    }
    // 是否已进行过人脸采集
    private async collectedCheck() {
        const userCode = {
            code: this.userCode,
        };
        const isCollect =  await this.$api.httpGet('BaiDuApi/BaiDuFace/QueryHaveLifePhotoByCode', userCode);
        if (isCollect.Success) {
            if (isCollect.Data) {
                this.$dialog.alert({
                    title: '提示',
                    message: '您已上传过生活照。',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: isCollect.AllMessages,
            });
            return;
        }
    }
    // 示例图片预览
    private async preview(index: any) {
        ImagePreview({
            images: [
                'https://ehrhz.oss-cn-hangzhou.aliyuncs.com/IDCard_example.png',
                'https://ehrhz.oss-cn-hangzhou.aliyuncs.com/live_example.png',
                ],
            startPosition: index,
        });
    }
    // 监听手动输入的身份证号
    @Watch('userIDCode') private watchCodeInput() {
        if (this.userIDCode.length !== 0 && this.userIDCode.length === 18 && this.userIDCode !== '' && this.requestIDCode === true) {
            // 验证身份证号
            if (!check.checkIDCard(this.userIDCode, null)) {
                this.isDisabled = true;
                this.$notify('请填写正确的身份证号');
            } else if (this.imgIDCode !== '' && this.imgIDCode !== this.userIDCode) {
                this.isDisabled = true;
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证号与身份证照片不符，请重新输入身份证号或重新上传身份证正面照片。',
                });
            } else {
                this.getInfoByIDCode();
            }
        }
    }
    // 上传身份证照片
    private async getIDCard(IDCard: any) {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在检测，请稍等...',
        });
        if (IDCard.file.size > this.limitImgSize) {
            // 进行身份证正面照压缩
            let self = this;
            const img = new Image();
            img.src = IDCard.content;
            img.onload = () => {
                // 压缩
                let data = compress.img(img, 0.6);
                // 检测、上传
                self.IDCheck(data, IDCard);
            };
        } else {
            this.IDCheck(IDCard.content, IDCard);
        }
    }
    // 身份证检测
    private async IDCheck(imgStr: any, IDCard: any) {
        // Base64截去前缀
        this.ImgStr.IDCard = imgStr.substr(imgStr.lastIndexOf(',') + 1);
        // Base64转换File
        IDCard.file = compress.Base64ToFile(imgStr, IDCard.file.name);
        this.ImgStr.IDCardSize = IDCard.file.size; // 图片大小，单位字节
        // 限制大小
        if (this.ImgStr.IDCardSize > this.limitImgSize) {
            this.isDisabled = true;
            this.IDCardList = [];
            this.$dialog.alert({
                title: '错误',
                message: '照片过大，请重新上传小于5M的照片。',
            });
            return;
        }
        // 身份证检测
        const modal = {
            base64ImgStr: this.ImgStr.IDCard,
            idCardSide: 'front',
        };
        const checkResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/CheckIdCard', modal);
        if (checkResult.Success) {
            const checkInfo = JSON.parse(checkResult.Data);
            this.imgIDCode = checkInfo.words_result.公民身份号码.words;
            // 若需要填写身份证号，验证身份证号与身份证照片是否相符
            if (this.userIDCode !== '' && this.imgIDCode !== this.userIDCode && this.requestIDCode === true) {
                this.isDisabled = true;
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证号与身份证照片不符，请重新输入身份证号或重新上传身份证正面照片。',
                });
                return;
            }
            if (checkInfo.image_status === 'normal') {
                // 身份证上传阿里云
                const fileModel = IDCard.file;
                const formData = new FormData();
                formData.append('files', fileModel, fileModel.name);
                const uploadResult = await this.$api.httpPost('Announcement/CommonMethod/AddEnclosureAliyun', formData);
                if (uploadResult.Success) {
                    this.$toast.clear();
                    this.IDCardInfo.fileUrl = uploadResult.Data.Url;
                    this.IDCardInfo.resourceItemId = uploadResult.Data.Id;
                    this.IDCardInfo.fileSource = 1;
                    this.$toast.success('上传成功');
                } else {
                    this.isDisabled = true;
                    this.$toast.clear();
                    this.$dialog.alert({
                        title: '错误',
                        message: uploadResult.AllMessages,
                    });
                }
            } else if (checkInfo.image_status === 'reversed_side') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证正反面颠倒，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'non_idcard') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '上传的图片不是身份证照片，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'blurred') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证模糊，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'other_type_card') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '当前图片是其他类型证照，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'over_exposure') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证关键字段反光或过曝，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'over_dark') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证欠曝，请重新上传身份证正面照片。',
                });
            } else {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证检测失败，请重新上传身份证正面照片。',
                });
            }
        } else {
            this.isDisabled = true;
            this.IDCardList = [];
            this.$toast.clear();
            let errorMessage = checkResult.AllMessages;
            if (check.checkNull(checkResult.Data)) {
                const error = JSON.parse(checkResult.Data);
                if (error.error_code === 216201) {
                    errorMessage = '身份证识别失败！照片格式错误';
                }
            }
            this.$dialog.alert({
                title: '错误',
                message: errorMessage,
            });
        }
    }

    // 上传生活照
    private async getLive(live: any) {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在检测，请稍等...',
        });
        if (live.file.size > this.limitImgSize) {
            // 进行生活照压缩
            let self = this;
            const img = new Image();
            img.src = live.content;
            img.onload = () => {
                // 压缩
                let data = compress.img(img, 0.6);
                // 检测、上传
                self.LiveCheck(data, live);
            };
        } else {
            this.LiveCheck(live.content, live);
        }
    }
     // 人脸检测
     private async LiveCheck(imgStr: any, live: any) {
         // Base64截去前缀
        this.ImgStr.live = imgStr.substr(imgStr.lastIndexOf(',') + 1);
        // Base64转换File
        live.file = compress.Base64ToFile(imgStr, live.file.name);
        this.ImgStr.liveSize = live.file.size; // 图片大小，单位字节
        if (this.ImgStr.liveSize > this.limitImgSize) {
            this.isDisabled = true;
            this.LiveList = [];
            this.$dialog.alert({
                title: '错误',
                message: '照片过大，请重新上传小于5M的照片。',
            });
            return;
        }
        // 生活照上传阿里云
        const fileModel = live.file;
        const formData = new FormData();
        formData.append('files', fileModel, fileModel.name);
        const uploadResult = await this.$api.httpPost('Announcement/CommonMethod/AddEnclosureAliyun', formData);
        if (uploadResult.Success) {
            this.LiveInfo.fileUrl = uploadResult.Data.Url;
            this.LiveInfo.resourceItemId = uploadResult.Data.Id;
            this.LiveInfo.fileSource = 3;
            // 人脸检测
            let imgUrlStr = this.LiveInfo.fileUrl;
            if (this.LiveInfo.fileUrl.indexOf('https:') === -1 && this.LiveInfo.fileUrl.indexOf('http:') === -1) {
                imgUrlStr = 'http:' + this.LiveInfo.fileUrl;
            }
            const modal = {
                ImgStr: imgUrlStr,
                type: 'URL',
            };
            const checkResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/CheckFaceImage', modal);
            if (checkResult.Success) {
                if (checkResult.Data) {
                    if (checkResult.Data.result && checkResult.Data.result !== null) {
                        this.$toast.clear();
                        this.$toast.success('上传成功');
                    } else {
                        this.isDisabled = true;
                        this.LiveList = [];
                        this.$toast.clear();
                        this.$dialog.alert({
                            title: '错误',
                            message: checkResult.Data.error_msg,
                        });
                    }
                }
            } else {
                this.isDisabled = true;
                this.LiveList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: checkResult.AllMessages,
                });
            }
        } else {
            this.isDisabled = true;
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: uploadResult.AllMessages,
            });
        }
     }
    // 监听上传照片
    @Watch('IDCardList') private watchIDCardList() {
        if (this.IDCardList.length === 0 || this.IDCardList === '' || this.IDCardList === null || this.IDCardList === undefined || this.ImgStr.IDCardSize > this.limitImgSize) {
            this.isDisabled = true;
        } else {
            if (this.LiveList.length === 0 || this.ImgStr.liveSize > this.limitImgSize) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    @Watch('LiveList') private watchLiveList() {
        if (this.LiveList.length === 0 || this.LiveList === '' || this.LiveList === null || this.LiveList === undefined || this.ImgStr.liveSize > this.limitImgSize) {
            this.isDisabled = true;
        } else {
            if (this.IDCardList.length === 0 || this.ImgStr.IDCardSize > this.limitImgSize) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    // 保存
    private async save() {
        if (this.IDCardList.length === 0) {
            this.$notify('请上传身份证正面照片');
            this.isDisabled = true;
        } else if (this.LiveList.length === 0) {
            this.$notify('请拍照上传生活照');
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
            this.$toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '正在对比，请稍等...',
            });
            // 人脸对比
            const modal = {
                idCardBase64ImgStr: this.ImgStr.IDCard,
                liveBase64ImgStr: this.ImgStr.live,
            };
            const contrastResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/MatchFace', modal);
            if (contrastResult.Success) {
                if (contrastResult.Data.result && contrastResult.Data.result !== null) {
                    // 添加人脸库
                    if (this.userCode === '' || this.userCode === null || this.userCode === undefined) {
                        this.$toast.clear();
                        this.$dialog.alert({
                            title: '错误',
                            message: '工号获取失败，请重新进入或刷新页面。',
                        });
                    } else if (this.IDCardInfo === '' || this.IDCardInfo === null || this.IDCardInfo === undefined) {
                        this.$toast.clear();
                        this.$dialog.alert({
                            title: '错误',
                            message: '身份证信息获取失败，请重新上传身份证正面照。',
                        });
                    } else if (this.LiveInfo === '' || this.LiveInfo === null || this.LiveInfo === undefined) {
                        this.$toast.clear();
                        this.$dialog.alert({
                            title: '错误',
                            message: '生活照信息获取失败，请重新拍照上传生活照。',
                        });
                    } else {
                        this.FileList.push(this.IDCardInfo);
                        this.FileList.push(this.LiveInfo);
                        const addInfo = {
                            code: this.userCode,
                            Type: this.userType,
                            fileList: this.FileList,
                        };
                        const addResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/AddUserFaceFile', addInfo);
                        if (addResult.Success) {
                            this.$toast.clear();
                            this.isDisabled = true;
                            this.$toast.success('人脸保存成功');
                            // 保存成功后跳转路径
                            if (this.reactURL === '' || this.reactURL === null || this.reactURL === undefined) {
                                // this.$router.go(-1);
                            } else {
                                window.location.replace(this.reactURL);
                            }
                        } else {
                            this.$toast.clear();
                            this.isDisabled = false;
                            this.$dialog.alert({
                                title: '人脸保存失败',
                                message: addResult.AllMessages,
                            });
                        }
                    }
                } else {
                    this.$toast.clear();
                    this.isDisabled = false;
                    this.$dialog.alert({
                        title: '错误',
                        message: '照片对比失败，请重新上传照片。',
                    });
                }
            } else {
                this.$toast.clear();
                this.isDisabled = false;
                this.$dialog.alert({
                    title: '错误',
                    message: contrastResult.AllMessages,
                });
            }
        }
    }
}
